<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0 relative" [ngClass]="{ 'pointer-events-none': downloading }">
  @if (downloading) {
  <div class="fixed inset-0 z-50 bg-gray-200 bg-opacity-50 pointer-events-none"></div>
  }

  <!-- Header -->
  <div
    class="relative flex flex-0 items-center w-full h-16 px-4 z-49 shadow-lg dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
    <!-- Navigation toggle button -->

    <div class="flex items-center basis-1/4 cursor-pointer md:block" [routerLink]="['/dashboard']">
      <img class="h-9 w-auto block" [src]="_authService.getLogoPath()" />
    </div>
    <div class="basis-2/4 flex justify-between sm:justify-center items-center">
      @if (activeComponent && ((hasUserAnySubsOrLicence$ | async) || flagService.hasUserAnyFreeAccess())) {
      <span class="text-sm md:text-lg font-medium mb-1">
        @if (!nameEditing) {
        <div class="flex flex-col sm:flex-row">
          <span class="truncate">{{ activeComponent.title }} </span>
          @if (activeComponent?.concept) {
          <span> - {{ 'section.horizontal_nav.concept' | translate }}</span>
          }
          <!--                    <span class="ml-2 hover:cursor-pointer" *ngIf="!activeComponent?.concept && activeComponent.title" (click)="editName()">-->
          <!--                        <i class="far fa-edit"></i>-->
          <!--                    </span>-->
        </div>
        }
        @if (nameEditing) {
        <div class="flex flex-col sm:flex-row">
          <input class="truncate border rounded-md p-2" [(ngModel)]="activeComponent.title" [maxlength]="100" />
          @if (!activeComponent?.concept) {
          <span class="ml-2 hover:cursor-pointer self-center" (click)="saveName()">
            <i class="far fa-check text-lime-500"></i>
          </span>
          }
        </div>
        }
      </span>
      }
    </div>

    <div class="flex items-center basis-2/4 justify-end">
      @if (activeComponent?.storable && ((hasUserAnySubsOrLicence$ | async) || flagService.hasUserAnyFreeAccess())) {
      <div class="h-16 flex items-center justify-end px-2">
        <div [class.disabled]="saveLoading" [attr.disabled]="saveLoading ? true : null"
          class="bg-none hover:bg-primary hover:border-secondary hover:text-white border-2 border-secondary cursor-pointer text-secondary px-2 py-[4px] rounded-lg ease-in-out duration-500"
          (click)="!saveLoading && saveData()">
          @if (!saveLoading) {
          <span>{{ 'section.horizontal_nav.save' | translate }}</span>
          }
          @if (saveLoading) {
          <span>
            {{ 'section.horizontal_nav.save' | translate }}
            <i class="far fa-spinner animate-spin"></i>
          </span>
          }
        </div>
      </div>
      }

      @if ((hasUserAnySubsOrLicence$ | async) || flagService.hasUserAnyFreeAccess()) {
      <div class="h-16 flex items-center justify-end px-1">
        @if (activeComponent?.download) {
        <div [class.disabled]="downloading" [attr.disabled]="downloading ? true : null"
          class="bg-none hover:bg-primary hover:border-secondary hover:text-white border-2 border-secondary cursor-pointer text-secondary px-2 py-[4px] rounded-lg ease-in-out duration-500"
          data-testid="download-pdf-button" (click)="!downloading && downloadPdf()">
          <span class="whitespace-nowrap">
            <span class="md:hidden">
              {{ 'section.horizontal_nav.download_pdf.short' | translate }}
            </span>
            <span class="hidden md:inline">
              {{ 'section.horizontal_nav.download_pdf' | translate }}
            </span>
            @if (downloading) {
            <i class="ml-0.5 far fa-spinner animate-spin"></i>
            }
          </span>
        </div>
        }
      </div>
      }

      <div class="h-16 flex items-center justify-end pl-1 pr-2">
        @if ((hasUserAnySubsOrLicence$ | async) || flagService.hasUserAnyFreeAccess()) {
        <div mat-button [matMenuTriggerFor]="userMenu"
          class="bg-primary hover:bg-secondary hover:border-secondary hover:text-white cursor-pointer text-white px-3 py-[6px] rounded-lg ease-in-out duration-500 whitespace-nowrap">
          <span class="hidden md:block">{{ 'section.horizontal_nav.new_calculation' | translate }}</span>
          <span class="md:hidden block">{{ 'section.horizontal_nav.new_calculation_short' | translate }}</span>
        </div>
        }
        <mat-menu #userMenu="matMenu">
          @if ((flagService.isEnabled$('ff_split_standard') | async) && !(activeStandardSubscription$ | async)) {
          @if (
          (companyHistoricalLicence$ | async) ||
          (activeHistoricalSubscription$ | async) ||
          (activeHistoricalUserLicenceDate$ | async)
          ) {
          <button mat-menu-item (click)="createCalculation('historical')">
            {{ 'section.horizontal_nav.historical' | translate }}
          </button>
          }
          @if (
          (companyProbabilityLicence$ | async) ||
          (activeProbabilitySubscription$ | async) ||
          (activeProbabilityUserLicenceDate$ | async)
          ) {
          <button mat-menu-item (click)="createCalculation('probability')">
            {{ 'section.horizontal_nav.probability' | translate }}
          </button>
          }
          @if (
          (companyFinMathLicence$ | async) ||
          (activeFinMathSubscription$ | async) ||
          (activeFinMathUserLicenceDate$ | async)
          ) {
          <button mat-menu-item (click)="createCalculation('fin_math')">
            {{ 'section.horizontal_nav.fin_math' | translate }}
          </button>
          }
          }
          @if (
          (!(flagService.isEnabled$('ff_split_standard') | async) && (companyLicence$ | async)) ||
          (activeStandardSubscription$ | async) ||
          (activeUserLicenceDate$ | async)
          ) {
          <button mat-menu-item (click)="createCalculation('historical')">
            {{ 'section.horizontal_nav.historical' | translate }}
          </button>
          <button mat-menu-item (click)="createCalculation('probability')">
            {{ 'section.horizontal_nav.probability' | translate }}
          </button>
          <button mat-menu-item (click)="createCalculation('fin_math')">
            {{ 'section.horizontal_nav.fin_math' | translate }}
          </button>
          }

          @if (
          ((flagService.isEnabled$('ff_real_estate_profit') | async) &&
          ((activeRentPropertySubscription$ | async) ||
          (activeUserRentPropertyLicenceDate$ | async) ||
          (companyRentPropertyLicence$ | async))) ||
          flagService.hasUserFreeAccess('ff_real_estate_profit')
          ) {
          <button mat-menu-item (click)="createCalculation('profit')">
            {{ 'section.calculations.estates.title' | translate }}
          </button>
          }
          @if (
          ((flagService.isEnabled$('ff_mortgage_and_investment') | async) &&
          ((activeMortgageInvestSubscription$ | async) ||
          (activeUserMortgageInvestLicenceDate$ | async) ||
          (companyMortgageInvestLicence$ | async))) ||
          flagService.hasUserFreeAccess('ff_mortgage_and_investment')
          ) {
          <button mat-menu-item (click)="createCalculation('mortgage')">
            {{ 'project.mortgage.title' | translate }}
          </button>
          }

          <!-- ADD PRODUCT GUIDE (step-16)
        <button
          mat-menu-item
          (click)="createCalculation('example')"
                            *ngIf="
                                exampleEnabled &&
                                ((activeExampleSubscription$ | async) ||
                                    (activeUserExampleLicenceDate$ | async) ||
                                    (companyExampleLicence$ | async))
                            "
          >
          {{ 'project.example.title' | translate }}
        </button>
        -->
        </mat-menu>
      </div>

      <mat-icon class="menu-icon kfpi-question mr-2 text-2xl cursor-pointer hover:text-primary ease-in-out duration-500"
        aria-hidden="false" aria-label="Example user verified icon" (click)="videoDialog()"></mat-icon>

      <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
        <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
      </button>
    </div>
  </div>

  <!-- Content -->
  <div id="layout" class="flex flex-col flex-auto">
    @if (true) {
    <router-outlet></router-outlet>
    }
  </div>
</div>

<!-- Navigation -->
@if (navLang) {
<fuse-vertical-navigation id="vertical-nav" class="bg-white light print:hidden w-full fixed right-0"
  [mode]="isScreenSmall ? 'over' : 'side'" [name]="'mainNavigation'" [navigation]="navLang" [opened]="!isScreenSmall">
  <!-- Navigation header hook -->
  <ng-container fuseVerticalNavigationContentHeader>
    <div class="h-18 flex flex-row items-center justify-between px-4">
      <div>
        <button mat-icon-button [matMenuTriggerFor]="languages">
          <ng-container *ngTemplateOutlet="flagImage; context: { $implicit: this.lang }"></ng-container>
        </button>
        <!-- Language menu -->
        <mat-menu [xPosition]="'before'" #languages="matMenu">
          @for (lang of availableLangs; track lang) {
          <button mat-menu-item (click)="setLanguage(lang.id.toLowerCase())">
            <span class="flex items-center">
              <ng-container *ngTemplateOutlet="flagImage; context: { $implicit: lang.id }"></ng-container>
              <span class="ml-3">{{ lang.label }}</span>
            </span>
          </button>
          }
        </mat-menu>
        <!-- Flag image template -->
        <ng-template let-lang #flagImage>
          <span class="relative w-6 shadow rounded-sm overflow-hidden">
            <span class="absolute inset-0 ring-1 ring-inset ring-black ring-opacity-10"></span>
            <img class="w-full" [src]="'assets/images/flags/' + flagCodes[lang]?.toUpperCase() + '.svg'" [alt]="lang" />
          </span>
        </ng-template>
      </div>
      <div>
        <button mat-icon-button class="scale-150" (click)="toggleNavigation('mainNavigation')">
          <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
        </button>
      </div>
    </div>
    <div class="items-center text-center mt-[60px]">
      <div class="text-xl font-semibold flex flex-row ml-4">
        @if (flagService.isEnabled$('ff_new_branding') | async) {
        <div class="mr-2 ml-2 self-center">
          @if (loggedUser?.avatar) {
          <img class="h-12 w-12 block rounded-full border-black object-cover" [src]="loggedUser?.avatar" />
          }
          @if (!loggedUser?.avatar) {
          <div class="h-12 w-12 flex items-center justify-center
                                rounded-full text-2xl bg-[#D1D1D6] text-white border-gray-50 border-4">
            <svg-icon src="assets/icons/kfpicons/image.svg" class="text-white icon-size-4"></svg-icon>
          </div>
          }
        </div>
        }
        <div class="flex flex-col text-primary2 text-2xl font-bold items-start">
          <span class="hover:cursor-pointer" [routerLink]="['/profile']">{{ loggedUser?.firstname }} {{
            loggedUser?.lastname }}</span>
          @if (loggedUser?.position) {
          <span class="text-md text-primary2">{{ loggedUser.position }}</span>
          }
          @if (!loggedUser?.position) {
          <span class="text-md text-primary2 ml-1">-----</span>
          }
        </div>
      </div>
      <mat-divider class="m-6"></mat-divider>
      <!-- Components -->
      <div class="flex items-center ml-auto"></div>
    </div>
    <!-- User -->
    <div class="flex flex-col items-center w-full"></div>
  </ng-container>
</fuse-vertical-navigation>
}